

export const buildUrlBlockListByOrderId = (id: any) => `/api/v1/mvp/order/${id}/black-list/`;
